import { render, staticRenderFns } from "./OverflowTooltip.vue?vue&type=template&id=001b53db&scoped=true&"
import script from "./OverflowTooltip.vue?vue&type=script&lang=js&"
export * from "./OverflowTooltip.vue?vue&type=script&lang=js&"
import style0 from "./OverflowTooltip.vue?vue&type=style&index=0&id=001b53db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b53db",
  null
  
)

export default component.exports